import { SET_BUDGET_CATEGORIES } from "../../../constants";

export const setBudgetCategories = (budgetCategories: any = []) => ({
  type: SET_BUDGET_CATEGORIES,
  payload: budgetCategories,
});
